interface LocalizedName {
  name?: string;
  nameEn?: string;
  nameTc?: string;
  nameSc?: string;
}

// Temporary business override for Oncology. Keep this list in the requested order
// in both booking apps; remove it when the temporary arrangement ends.
const TEMPORARY_ONCOLOGY_DOCTOR_ORDER = [
  ['楊庭恩', '杨庭恩'],
  ['陳方婷', '陈方婷'],
  ['李慧敏'],
  ['招國榮', '招国荣'],
  ['林河清'],
  ['盧頴嬋', '盧穎嬋', '卢颖婵'],
];

const normalizeName = (name: string) =>
  name.normalize('NFKC').toLowerCase().replace(/\s+/g, '').replace(/(?:醫生|医生)$/, '');

const getNames = (option: LocalizedName) =>
  [option.nameTc, option.nameSc, option.nameEn, option.name]
    .filter((name): name is string => !!name)
    .map(normalizeName);

const oncologyNames = new Set(['腫瘤科', '肿瘤科', 'oncology']);

const getDoctorPriority = (careProvider: LocalizedName) => {
  const names = getNames(careProvider);
  const index = TEMPORARY_ONCOLOGY_DOCTOR_ORDER.findIndex((aliases) =>
    aliases.some((alias) => names.includes(alias))
  );
  return index < 0 ? TEMPORARY_ONCOLOGY_DOCTOR_ORDER.length : index;
};

export const compareTemporaryOncologyDoctors = (
  specialty: LocalizedName | undefined,
  left: LocalizedName,
  right: LocalizedName
) => {
  if (!specialty || !getNames(specialty).some((name) => oncologyNames.has(name))) return 0;

  return getDoctorPriority(left) - getDoctorPriority(right);
};
